module.exports = __webpack_public_path__ + "img/delete.22bb518e.svg";